import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import SortableTh from '../shared/table/SortableTh';
import ListView from '../shared/lists/ListView';
import useFilter from '../../utilities/useFilter';
import FormControl from '../shared/inputs/FormControl';
import JobSearchItem from './JobSearchItem';
import ExportButton from '../shared/buttons/ExportButton';
import SearchBar from '../shared/search/SearchBar';


const JobSearchList = ({
    navigateUrl
}) => {
    const editUrl = '/customers/edit/';
    const getUrl = `/api/jobs/search`;

    const defaultFilter = {
        searchObject: {},
        sortColumn: "InstallationDate",
        sortDesc: true
    };

    const { items, filter, setFilter, pageInfo, isLoaded, submitFilter } = useFilter(getUrl, defaultFilter, true);

    const tableHead = (
        <thead>
            <tr>
                <SortableTh
                    content="Customer"
                    sortName="CustomerFirstName"
                    sort={pageInfo}
                />
                <SortableTh
                    hide="md"
                    content="Job#"
                    sortName="JobNumber"
                    sort={pageInfo}
                />
                <SortableTh
                    hide="md"
                    content="Designer"
                    sortName="DesignerLastName"
                    sort={pageInfo}
                />
                <SortableTh
                    width="90px"
                    content="Install"
                    sortName="InstallationDate"
                    sort={pageInfo}
                />
                <SortableTh
                    width="75px"
                    content="Total"
                    sortName="Total"
                    sort={pageInfo}
                />
                <SortableTh
                    hide="sm"
                    content="Lead Source"
                    sortName="LeadSourceName"
                    sort={pageInfo}
                />
                <SortableTh
                    hide="lg"
                    content="Sub Source"
                    sortName="SubLeadSourceName"
                    sort={pageInfo}
                />
                <th className="button-cell" style={{ width: "40px" }}>
                    <ExportButton
                        disabled={items === undefined || items === null || items.length === 0}
                        filter={filter}
                        url="/api/export/jobs"
                    />
                </th>
            </tr>
        </thead>
    );

    const listItems = items && items.map((item) =>
        <JobSearchItem
            editItem={() => navigateUrl(editUrl + item.customerId + '#jobs')}
            fetchData={filter.submitFilter}
            item={item}
            key={item.id}
        />
    );

    return (
        <React.Fragment>
            <SearchBar filter={filter} setFilter={setFilter} submitFilter={submitFilter}/>
            <Row>
                <Col>
                    <ListView
                        animate={false}
                        canAdd={false}
                        items={listItems}
                        tableHead={tableHead}
                        isLoaded={isLoaded}
                        pageInfo={pageInfo}
                    />
                </Col>
            </Row>
        </React.Fragment>
    );
}

export default JobSearchList;